import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue"
import PositionDetails from "@/modules/Missions/components/Details/ManageTeamRoles/StaffingPositionDetails/PositionDetails.vue"
import { ApplicationActions } from "./constant"
import {
  ApproveMissionStaffingApplicationMutation,
  ApproveMissionStaffingApplicationMutationMutation,
  ApproveMissionStaffingApplicationMutationMutationVariables,
  RejectMissionStaffingApplicationMutation,
  RejectMissionStaffingApplicationMutationMutation,
  RejectMissionStaffingApplicationMutationMutationVariables,
  ShortlistMissionStaffingApplicationMutation,
  ShortlistMissionStaffingApplicationMutationMutation,
  ShortlistMissionStaffingApplicationMutationMutationVariables,
  PendingMissionStaffingApplicationFragmentFragment,
} from "@/gql"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import { RefetchQueryDescription } from "apollo-client/core/watchQueryOptions"


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmApplications',
  props: {
    selectedApplication: null,
    confirmDialogText: null,
    selectedAction: null,
    show: { type: Boolean },
    refetchQueries: null
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props as {
  selectedApplication: PendingMissionStaffingApplicationFragmentFragment
  confirmDialogText: {
    message: string
    btnText: string
  }
  selectedAction: (typeof ApplicationActions)[keyof typeof ApplicationActions] | null
  show: boolean
  refetchQueries: RefetchQueryDescription
}

const { mutate } = useMutation()
const { addSuccess } = useNotification()



const observer = ref<any>(null)
const isSubmitting = ref(false)
const showRejectionForm = ref(false)
const showSubmitDialog = ref(false)

watch(
  () => props.show,
  (newVal) => {
    showSubmitDialog.value = newVal
  },
  { immediate: true }
)

const onCloseModal = () => {
  showSubmitDialog.value = false
  emit("close")
}

const onConfirmApplication = () => {
  if (props.selectedAction === ApplicationActions.approve) {
    onApproveApplication()
  } else if (props.selectedAction === ApplicationActions.decline) {
    showRejectionForm.value = true
  } else if (props.selectedAction === ApplicationActions.shortlist) {
    onShortlistApplication()
  }
}

const onApproveApplication = async () => {
  isSubmitting.value = true
  const result = await mutate<
    ApproveMissionStaffingApplicationMutationMutation,
    ApproveMissionStaffingApplicationMutationMutationVariables
  >({
    mutation: ApproveMissionStaffingApplicationMutation,
    variables: {
      id: props.selectedApplication.prn,
    },
    refetchQueries: props.refetchQueries,
    done: () => {
      isSubmitting.value = false
    },
  })

  if (
    result?.data?.approveMissionStaffingApplication &&
    !result?.data?.approveMissionStaffingApplication.error
  ) {
    addSuccess("Application approved successfully")
    emit("close")
  }
}

const form = ref({
  rejectionReason: "",
})

const onDeclineApplication = async () => {
  isSubmitting.value = true
  const result = await mutate<
    RejectMissionStaffingApplicationMutationMutation,
    RejectMissionStaffingApplicationMutationMutationVariables
  >({
    mutation: RejectMissionStaffingApplicationMutation,
    variables: {
      id: props.selectedApplication.prn,
      rejectionReason: form.value.rejectionReason,
    },
    done: () => {
      isSubmitting.value = false
    },
    refetchQueries: props.refetchQueries,
  })

  if (
    result?.data?.rejectMissionStaffingApplication &&
    !result?.data?.rejectMissionStaffingApplication.error
  ) {
    addSuccess("Application declined successfully")
    form.value.rejectionReason = ""
    emit("close")
  }
}

const onShortlistApplication = async () => {
  isSubmitting.value = true
  const result = await mutate<
    ShortlistMissionStaffingApplicationMutationMutation,
    ShortlistMissionStaffingApplicationMutationMutationVariables
  >({
    mutation: ShortlistMissionStaffingApplicationMutation,
    variables: {
      id: props.selectedApplication.prn,
    },
    done: () => {
      isSubmitting.value = false
    },
    refetchQueries: props.refetchQueries,
  })

  if (
    result?.data?.shortlistMissionStaffingApplication &&
    !result?.data?.shortlistMissionStaffingApplication.error
  ) {
    addSuccess("Application shortlisted successfully")
    emit("close")
  }
}

const onSubmitRejection = async () => {
  const isValid = await observer.value.validate()
  if (!isValid) return

  await onDeclineApplication()
}

const onCancel = () => {
  emit("close")
}

return { __sfc: true,mutate, addSuccess, props, emit, observer, isSubmitting, showRejectionForm, showSubmitDialog, onCloseModal, onConfirmApplication, onApproveApplication, form, onDeclineApplication, onShortlistApplication, onSubmitRejection, onCancel, PositionDetails }
}

})